/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import InfluenceCass from 'solis/logic/board/influence/cass';


// Mirrors cpp board_zone_influence: one source colony's influence on a zone.
export default class ZoneInfluence extends Logic
{
  constructor (zone, sourceColony)
  {
    super(zone);

    this.sourceColony = sourceColony;
  }


  ensureInfluence ()
  {
    if (this.object.getInfluence(this.sourceColony) === null)
    {
      this.object.createInfluence(this.sourceColony);
    }
  }


  updateInfluence (value, now)
  {
    new InfluenceCass(this.object.getInfluence(this.sourceColony)).updateValue(value, now);
  }


};
